import React, { useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import GLXOutputCommonTable from "../../../LUPManagement/ProjectManagement/ProjectEditor/ProcedureOutputDesign/GLXOutputCommonTable";
import GLXMAKEDATA from "../../../LUPManagement/ProjectManagement/ProjectEditor/ProcedureOutputDesign/GLXMAKEDATA";
import GLXBABEGLM from "../../../LUPManagement/ProjectManagement/ProjectEditor/ProcedureOutputDesign/GLXBABEGLM";
import GLXRPT from "../../../LUPManagement/ProjectManagement/ProjectEditor/ProcedureOutputDesign/GLXRPT";
import Moment from "react-moment";
import GLXTTEST from "../../../LUPManagement/ProjectManagement/ProjectEditor/ProcedureOutputDesign/GLXTTEST";

const ProjectOutputConsole = ({ ids, outputGeneratedDT, outputs, outputLoader, isFullScreenMode, isFullScreen, setIsFullScreen }) => {
  const outputRef = useRef(null);
  const clientLabel = JSON.parse(localStorage.getItem("clientLabel"));
  const projectLabel = JSON.parse(localStorage.getItem("projectLabel"));

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="overflow-hidden w-100">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-1">
          <i className="fa-solid fa-computer"></i>
          <h6 className="m-0">{ids?.name} Output</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title="Print Outputs"
            className="fa-solid fa-print CP"
            onClick={handlePrint}
          />
          <div className="vr" />
          <i title={`${isFullScreen ? "Minimize" : "Maximize"} Console`} className={`fa-solid ${isFullScreen ? "fa-minimize" : "fa-maximize"} CP`} onClick={() => setIsFullScreen(!isFullScreen)} />
        </div>
      </div>
      <div
        ref={outputRef}
        className="p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 70px)"
            : "calc(100vh - 216px)",
          overflowY: "auto",
          fontSize: `14px`,
        }}
      >
        {outputLoader ? (
          <PageLoader />
        ) : outputs?.length > 0 ? (
          <div ref={componentRef}>
            <Table className="m-0 mb-2 border-start border-end custom-table" bordered hover striped>
              <thead>
                <tr>
                  <th className="text-center" colspan={2}>Header Information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sponsor Name</td>
                  <td>{clientLabel}</td>
                </tr>
                <tr>
                  <td>Project Id</td>
                  <td>{projectLabel}</td>
                </tr>
                <tr>
                  <td>Study Id</td>
                  <td>{ids?.studyLabel}</td>
                </tr>
                <tr>
                  <td>Programmer Name</td>
                  <td>{ids?.updatorName}</td>
                </tr>
                <tr>
                  <td>Program Name</td>
                  <td>
                    {ids?.reportName}.glx
                  </td>
                </tr>
                <tr>
                  <td>Program Location</td>
                  <td>
                    /Generate Report/Program/{ids?.reportName}.glx
                  </td>
                </tr>
                <tr>
                  <td>Generated Date | Time</td>
                  <td>
                    <Moment format="DD MMM YYYY | HH:mm:ss">
                      {outputGeneratedDT}
                    </Moment></td>
                </tr>
                <tr>
                  <td>Software Version</td>
                  <td>v2.0.0</td>
                </tr>
              </tbody>
            </Table>
            {outputs?.map((proc, idx) => {
              const procName = Object.keys(proc).find(key => key.startsWith("Procedure"));
              let jsonCompatibleInJs = !(proc[procName] === "GLX RPT" || proc[procName] === "GLX REPORT") ? proc.output
                .replace(/\bNone\b/g, "null")
                .replace(/\bFalse\b/g, "false")
                .replace(/\bTrue\b/g, "true")
                .replace(/\bnan\b/g, "null") : proc.output;
              const output = (proc[procName] === "GLX RPT" || proc[procName] === "GLX REPORT") ? jsonCompatibleInJs : (jsonCompatibleInJs ? JSON.parse(jsonCompatibleInJs.replace(/'/g, '"')) : []);
              return (
                <div className="mb-3">
                  <div className="text-center">
                    <Form.Label className="mb-2 fw-bold" style={{ fontSize: 12 }}>{procName?.replace("_", " ")}: {proc[procName]}</Form.Label>
                  </div>
                  {(proc[procName] === "GLX SORT" ||
                    proc[procName] === "GLX STATS" ||
                    proc[procName] === "GLX DUPLICATE" ||
                    proc[procName] === "GLX OCCURRENCE" ||
                    proc[procName] === "GLX SWITCH" ||
                    proc[procName] === "GLX PK" ||
                    proc[procName] === "GLX TLFCNT" ||
                    proc[procName] === "GLX TLFSTATS" ||
                    proc[procName] === "GLX APPEND" ||
                    proc[procName] === "GLX DATA" ||
                    proc[procName] === "GLX MERGE") &&
                    <GLXOutputCommonTable output={output} />
                  }
                  {proc[procName] === "GLX MAKEDATA" &&
                    <GLXMAKEDATA output={output} />
                  }
                  {proc[procName] === "GLX BABEGLM" &&
                    <GLXBABEGLM output={output} />
                  }
                  {(proc[procName] === "GLX TTEST" || proc[procName] === "GLX PROPTEST") &&
                    <GLXTTEST output={output} />
                  }
                  {(proc[procName] === "GLX RPT" || proc[procName] === "GLX REPORT") &&
                    <GLXRPT output={output} />
                  }
                </div>
              );
            })}
          </div>
        ) : (
          <div className="hstack justify-content-center h-100">
            <div className="px-2 fw-bold fontSize12 text-center">
              <div>Output not Found</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectOutputConsole;
